"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _RoutesProvider = _interopRequireDefault(require("./RoutesProvider"));

var _flattenRoutes = _interopRequireDefault(require("../lib/flattenRoutes"));

var _ScrollToElement = _interopRequireDefault(require("./ScrollToElement"));

/**
 * Renders provided routes using React Router's Switch & Route components.
 * @param {Routes} routes A list of routes to be used within an app. See
 * the README for this module for more guidance on what to provide.
 */
var AllRoutes = function AllRoutes(_ref) {
  var appRoutes = _ref.routes,
      children = _ref.children;

  var _useState = (0, _react.useState)((0, _flattenRoutes["default"])(appRoutes)),
      flattenedRoutes = _useState[0];

  return /*#__PURE__*/_react["default"].createElement(_RoutesProvider["default"], {
    routes: appRoutes
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ScrollToElement["default"], null), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, flattenedRoutes.map(function (route) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      key: route.path,
      path: route.path,
      component: route.component,
      exact: true
    });
  }), !children && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    component: function component() {
      return /*#__PURE__*/_react["default"].createElement("p", null, "404");
    }
  }), children)));
};

var _default = AllRoutes;
exports["default"] = _default;